"use client";

import { useClientConfig } from "@providers/app-provider/client-app-provider";

export const useAlgoliaIndex = () => {
  const clientConfig = useClientConfig();
  const stand = clientConfig?.config.stand || "dev";

  return {
    industrialVacancy: stand === "dev" ? "karirhub_sandbox_industrial_vacancies" : "karirhub_industrial_vacancies",
    microVacancy: stand === "dev" ? "karirhub_sandbox_micro_vacancies" : "karirhub_micro_vacancies",
    company: stand === "dev" ? "karirhub_sandbox_companies" : "karirhub_companies",
    government: stand === "dev" ? "karirhub_sandbox_governments" : "karirhub_governments",
  };
}